export class CurrentUser {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  roles: Role [];
  isActive: boolean;

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
      this.roles = data.roles.map(value => new Role(value));
    }
  }

  getFullName() {
    return this.firstName + ' ' + this.lastName;
  }

  hasRole(roleName: string) {
    return this.roles.some(value => value.name === roleName);
  }
}

export class Role {
  id: number;
  name: string;

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
    }
  }
}

export enum RoleEnum {
  ROLE_REPORTER= 'ROLE_REPORTER',
  ROLE_ADMIN = 'ROLE_ADMIN',
  ROLE_WEB_USER = 'ROLE_WEB_USER',
  ROLE_SADMIN = 'ROLE_SADMIN',
  ROLE_SCHEDULER = 'ROLE_SCHEDULER',
  ROLE_PRICING = 'ROLE_PRICING',
  ROLE_BUSINESS_OFFICER = 'ROLE_BUSINESS_OFFICER',
  ROLE_USER_MANAGER = 'ROLE_USER_MANAGER',
  ROLE_TREASURER = 'ROLE_TREASURER',
  ROLE_TERMINAL_MANAGER = 'ROLE_TERMINAL_MANAGER',
  ROLE_TRAFFIC_MANAGER = 'ROLE_TRAFFIC_MANAGER',
  ROLE_TICKET_MANAGER = 'ROLE_TICKET_MANAGER',
  ROLE_STORAGE_MANAGER = 'ROLE_STORAGE_MANAGER'
}



// WEBPACK FOOTER //
// ./src/app/shared/model/CurrentUser.ts